import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';
import './index.css';

import LoginPage     from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TeamPage      from './pages/TeamPage';
import TargetsPage   from './pages/TargetsPage';
import HistoryPage   from './pages/HistoryPage';
import AdminPage     from './pages/AdminPage';
import ReportsPage   from './pages/ReportsPage';
import PayoutsPage   from './pages/PayoutsPage';
import ProfilePage   from './pages/ProfilePage';
import BottomNav     from './components/BottomNav';

function ProtectedRoute({ children, require: req }) {
  const auth = useAuth();
  if (auth.loading) return <div className="loading-page"><div className="spinner"/></div>;
  if (!auth.user) return <Navigate to="/login" replace />;
  if (req && !req(auth)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-page"><div className="spinner"/></div>;
  return (
    <>
      <Routes>
        <Route path="/login"   element={user ? <Navigate to="/" replace /> : <LoginPage />} />
        <Route path="/"        element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/team"    element={<ProtectedRoute require={a=>a.canSupervise}><TeamPage /></ProtectedRoute>} />
        <Route path="/targets" element={<ProtectedRoute require={a=>a.canSupervise}><TargetsPage /></ProtectedRoute>} />
        <Route path="/history" element={<ProtectedRoute><HistoryPage /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute require={a=>a.canManage}><ReportsPage /></ProtectedRoute>} />
        <Route path="/admin"   element={<ProtectedRoute require={a=>a.canManage}><AdminPage /></ProtectedRoute>} />
        <Route path="/payouts" element={<ProtectedRoute require={a=>a.isAdmin}><PayoutsPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="*"        element={<Navigate to="/" replace />} />
      </Routes>
      {user && <BottomNav />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ToastProvider>
          <AppRoutes />
        </ToastProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
